import { render } from "./AboutDialog.vue?vue&type=template&id=3f436820&ts=true"
import script from "./AboutDialog.vue?vue&type=script&lang=ts"
export * from "./AboutDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__